import React from 'react'
import { Region } from '@enonic/react-components';

import Section from '../../../react4xp/components/Section'
import RichText from '../../../react4xp/components/RichText'
import CampaignHero from '../../../react4xp/components/CampaignHero'

function CampaignLayout({title, intro, cta, image, video, text, isFullWidth, regions}) {

	return (
		<div className='page-campaign'>

				<CampaignHero
                    bgColor='red'
					title={title}
					content={intro}
					button={{
						text: cta?.text,
						href: cta?.href,
						external: cta?.external
					}}
					image={image}
					video={video}
					fullWidth={isFullWidth}
				/>

				<Region name={regions.main.name} regionData={regions.main} />

				<Section
					bgColor='white'
					className='page-campaign__article'
					paddingBottom='big'
				>
					<div className='container'>
						<div className='row'>
							<div className='col-md-10 col-lg-8 offset-lg-1 col-xl-6 offset-xl-2'>
								<RichText content={text} />
							</div>
						</div>
					</div>
				</Section>
		</div>
	)
}

export default (props) => <CampaignLayout {...props} />
